import React, { useEffect, useState } from 'react';
import { Image, Modal } from 'react-bootstrap';
import { connect, useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';

import AuthButton from 'components/base/AuthButton';
import PromptButton, { BUTTON_TYPES } from 'components/base/prompt/BaseButtons';
import { CustomTitleWithDropDown } from 'components/customer/CustomTitleWithDropDown';
import { CustomTitleLabel } from 'components/earning/CustomBaseComponments';
import CustomerFilterableDropdown from 'components/transactions/CustomerFilterableDropdown';
import { COUPON_TYPES } from 'config/CustomEnums';
import { PermissionCodes } from 'config/PermissionCodes';
import { ToastType, defaultDelayTime } from 'models/NavBarModel';

import { createAction } from 'utils';

import CloseIcon from 'assets/images/prompt_close_icon.svg';

import './CouponRemoveOwnerModal.scss';

const mapPropsToState = (state) => ({
  customer: state.customerList.customer,
});

const CouponRemoveOwnerModal = ({ customer, coupon, show, setShow }) => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();

  const [remarks, setRemarks] = useState(null);

  console.log('selectCustomer Coupon', customer, coupon);

  const onClose = () => {
    setShow(false);
  };

  const showSuccessToast = () => {
    dispatch({
      type: 'navBars/updateState',
      payload: {
        saveDiscardToastShowing: {
          value: true,
          type: ToastType.operatedSuccessfully,
          delayTime: defaultDelayTime,
        },
      },
    });
  };

  const updateAction = () => {
    dispatch(
      createAction('singleCoupon/reclaimCoupon')({
        couponPK: coupon?.pk,
        remarks,
        afterAction: () => {
          setShow(false);
          showSuccessToast();
          history.push(location);
        },
      }),
    );
  };

  const primaryButtonAction = () => {
    updateAction();
  };

  useEffect(() => {
    if (show) {
      setRemarks();
    }
  }, [show]);

  return (
    <Modal
      show={show}
      onHide={onClose}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
    >
      <Modal.Body className="base-prompt-container customer-detail-prompt coupon-remove-owner">
        <Image
          src={CloseIcon}
          className="base-prompt-close-button customer-detail-prompt-close-button"
          onClick={onClose}
        />

        <label className="customer-detail-modal-title">Confirmation</label>

        <CustomTitleLabel
          title={
            coupon?.couponType === COUPON_TYPES.TICKET ? 'Ticket' : 'Coupon'
          }
        />
        <div className="select-coupon-value">
          <label>{coupon?.templateName}</label>
          {coupon?.store?.displayStoreName ? (
            <ul>
              <li>{coupon?.store?.displayStoreName}</li>
            </ul>
          ) : null}
        </div>

        <CustomTitleLabel title="Remarks (optional)" />
        <textarea
          onChange={({ target }) => {
            const value = target.value;
            setRemarks(value);
          }}
          className="custom-textarea-input-box customer-detail-textarea-input"
          value={remarks}
        />

        <div className="base-prompt-buttons customer-detail-prompt-buttons">
          <PromptButton
            title="Cancel"
            action={onClose}
            type={BUTTON_TYPES.secondary}
          />
          <PromptButton
            title="Confirm"
            action={primaryButtonAction}
            requires={PermissionCodes.changeCoupon}
            type={BUTTON_TYPES.main}
          />
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default connect(mapPropsToState)(CouponRemoveOwnerModal);
